import { render, staticRenderFns } from "./POLineItemsTab.vue?vue&type=template&id=70ca1988&scoped=true&"
import script from "./POLineItemsTab.vue?vue&type=script&lang=js&"
export * from "./POLineItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./POLineItemsTab.vue?vue&type=style&index=0&id=70ca1988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca1988",
  null
  
)

export default component.exports